export const isAndroid = ()=>{//@ts-ignore
  return /android/i.test(navigator.userAgent) || /android/i.test(navigator.vendor) || /android/i.test(navigator.opera)
}